import Typography from '@mui/material/Typography';
import type { JSX } from 'react';

export const HOME = 'HOME';
export const SUMMARY = 'Summary';
export const CONTRACTS_AND_ASSETS = 'Contracts & Assets';
export const ASSETS = 'Assets';
export const NON_LEASED_ASSETS = 'Non-Leased Assets';
export const CONTRACTS = 'Contracts';
export const ALL_CONTRACTS = 'All Contracts';
export const ALL_ASSETS = 'All Assets';
export const INVOICES = 'Invoices';
export const HUNTINGTON_BANCSHARES = 'Huntington Bancshares Incorporated.';
export const PRIVACY_POLICY = 'Privacy Policy';
export const SECURITY_CENTER = 'Security Center';
export const TERMS_OF_USE = 'Terms of Use';
export const FOOTER =
	'The Huntington National Bank is an Equal Housing Lender and Member FDIC. Huntington, Huntington Bank, and the Huntington Brandmark are service marks of Huntington Bancshares Incorporated. © 2026 Huntington Bancshares Incorporated.';

// Asset Views
export const ASSET_SPECS = 'Asset Specifications';
export const CUSTOMER_ATTRIBUTES = 'Customer Attributes';
export const ASSET_LOCATION = 'Asset Location';
export const LEASE_DETAILS = 'Lease Details';

// InvoiceAsset Views
export const ASSET_DETAILS = 'Asset Details';
export const INVOICE_DETAILS = 'Invoice Details';
export const BILLING_LOCATION = 'Billing Location';

// Column Headers - Contract
export const CONTRACT_NO = 'Contract No';
export const ACCOUNT_NAME = 'Account';
export const STATUS = 'Status';
export const START_DATE = 'Start Date';
export const END_DATE = 'End Date';
export const CLIENT = 'Client';
export const TERM = 'Term';
export const END_OF_TERM = 'End Of Term';
export const LAST_BILLED_RENT = 'Last Billed Rent';

// Column Headers - Asset
export const ASSET_NUMBER = 'Asset No';
export const CATEGORY = 'Category';
export const DESCRIPTION = 'Description';
export const MANUFACTURER = 'Manufacturer';
export const MODEL_NO = 'Model No';
export const SERIAL_NO = 'Serial No';
export const QUANTITY = 'Quantity';

// Column Headers - Customer Attributes
export const DEPARTMENT = 'Department';
export const COST_CENTER = 'Cost Center';
export const ASSIGNED_TO = 'Assigned To';
export const CLASSIFICATION = 'Classification';
export const ATTRIBUTE1 = 'Attribute 1';
export const ATTRIBUTE2 = 'Attribute 2';
export const ATTRIBUTE3 = 'Attribute 3';
export const ATTRIBUTE4 = 'Attribute 4';
export const ATTRIBUTE5 = 'Attribute 5';
export const ATTRIBUTE6 = 'Attribute 6';
export const ATTRIBUTE7 = 'Attribute 7';
export const ATTRIBUTE8 = 'Attribute 8';
export const ATTRIBUTE9 = 'Attribute 9';
export const ATTRIBUTE10 = 'Attribute 10';
export const ATTRIBUTE11 = 'Attribute 11';
export const ATTRIBUTE12 = 'Attribute 12';
export const ATTRIBUTE13 = 'Attribute 13';
export const ATTRIBUTE14 = 'Attribute 14';
export const ATTRIBUTE15 = 'Attribute 15';

// Column Headers - Asset Location
export const ADDRESS_LINE_1 = 'Address Line 1';
export const ADDRESS_LINE_2 = 'Address Line 2';
export const ADDRESS_LINE_3 = 'Address Line 3';
export const ADDRESS_LINE_4 = 'Address Line 4';
export const BUILDING = 'Building';
export const FLOOR = 'Floor';
export const ROOM = 'Room';

// Column Headers - Lease Details
export const END_OF_TERM_OPTION = 'End of Term Option';
export const TOTAL_FINANCED = 'Total Amount Financed';
export const PO_NUMBER = 'Po. No';
export const PURCHASE_ORDER_NO = 'Purchase Order No.';
export const SUPPLIER_NAME = 'Supplier Name';
export const SUPPLIER_INVOICE_NO = 'Supplier Invoice No.';
export const RETURNED_DATE = 'Returned Date';
export const ASSET_TERMINATION_TYPE = 'Asset Termination Type';
export const ASSET_TERMINATION_DATE = 'Asset Termination Date';
export const RELEASE_CONTRACT_NO = 'Re-lease Contract No';
export const LEASE_DATE = 'Lease Date';
export const LAST_BILLED_AMOUNT = 'Last Billed Amount';
export const LAST_BILLED_DATE = 'Last Billed Date';

// Audit Log
export const UPDATE_HISTORY = 'Update History';
export const AUDIT_LOG = 'Audit Log';

// Summary

export const TOTAL_EQUIPMENT_COST = 'Total Equipment Cost';

// Summary Chart Titles
export const ASSET_CATEGORY_CHART = 'Asset Category';
export const ASSET_BY_MANUFACTURER_CHART = 'Asset By Manufacturer';
export const ASSET_BY_CLIENT_ATTRIBUTES_CHART = 'Asset by Client Attributes';
export const INVOICE_DETAILS_CHART = 'Invoice Details';
export const ASSET_BY_END_OF_LEASE_DATE_CHART = 'Asset By End of Lease Date';
export const ASSETS_BY_CATEGORY = 'Assets by Category';

// Invoice Views
export const INVOICE_SUMMARY = 'Invoice Summary';
export const BILLING_INFORMATION = 'Billing Information';

//Invoice Summary fields
export const DATE = 'Date';
export const DUE_DATE = 'Due Date';
export const INVOICE_DATE = 'Invoice Date';
export const INVOICE_DUE_DATE = 'Invoice Due Date';
export const AMOUNT = 'Amount';
export const TAX_AMOUNT = 'Tax Amount';
export const TOTAL_INVOICE_BALANCE = 'Total Invoice Balance';
export const TOTAL_INVOICE_AMOUNT = 'Total Invoice Amount';

//Invoice Details fields
export const INVOICE_DESCRIPTION = 'Invoice Description';
export const CURRENCY = 'Currency';
export const OWNER_NAME = 'Owner Name';

//Billing/Location Information fields
export const INVOICE_NUMBER = 'Invoice No';
export const ADDRESS_1 = 'Address 1';
export const ADDRESS_2 = 'Address 2';
export const ADDRESS_3 = 'Address 3';
export const ADDRESS_4 = 'Address 4';
export const CITY = 'City';
export const COUNTY = 'County';
export const STATE = 'State';
export const POSTAL_CODE = 'Zip Code';
export const COUNTRY = 'Country';

// Client Attributes Chart
export const CLIENT_ATTRIBUTES_CHART_TITLE = 'Assets by Client Attributes';
export const CLIENT_ATTRIBUTES_XAXIS_LABEL = 'Attributes';
export const CLIENT_ATTRIBUTES_YAXIS_LABEL = 'Total Assets';

export const ACCOUNT_LABEL = 'Account: ';
export const CONSORTIUM_LABEL = 'Consortium: ';
export const PROGRAM_LABEL = 'Program: ';
export const VENDOR_PROGRAM_LABEL = 'Vendor Program: ';
export const SELECT_AN_ACCOUNT = 'Select an Account';

export const LOADING = 'Loading';
export const LOADING_WITH_ELLIPSIS = 'Loading...';

export const ACCOUNT_NAME_FILTER =
	'Account name filter not applied. Invalid filter selection based on selected view.';

export const NO_ACCESS_HEADING = 'Error: Access Denied';
export const NO_ACCESS_MESSAGE =
	'Your account is inactive and you do not currently have permission to access this site. Please contact your administrator for more information.';
export const LOG_OUT = 'Log Out';

export const CONTROL_PANEL = 'Control Panel';
export const CIRCADIA_USERS = 'Circadia Users';
export const EDIT_USER = 'Edit User';
export const ADD_NEW_USER = 'Add New User';
export const USER_MANAGEMENT_DASHBOARD = 'User Management Dashboard';
export const USER_MANAGEMENT = 'User Management';
export const ADD_NEW_USER_SUBTITLE = 'Add New User';
export const ADD_ACCOUNT = 'Add Account';
export const REMOVE_ACCOUNT = 'Remove Account';
export const CONTACT_INFORMATION = 'Contact Information';
export const ACCOUNT_INFORMATION = 'Account Information';
export const BACK = 'Back';
export const CONTINUE = 'Continue';
export const SUBMIT = 'Submit';
export const USER_DETAILS = 'User Details';

export const ADD_UDF = 'ADD UDF';

// CSR Request Messages
export const CSR_REQUEST_SUCCESS =
	'Request submitted successfully. CSV download should begin shortly.';
export const CSR_REQUEST_ERROR = 'Failed to submit request. Please try again.';

// Login Page Text
export const LOGIN_HERO_TITLE = 'Welcome to Circadia';
export const LOGIN_BUTTON_LABEL = 'Log in';
export const LOGIN_SECTION_TITLE = 'Stay in Rhythm with the Lifecycle of your Assets';
export const LOGIN_SECTION_BODY =
	'Built on a powerful data analytics platform, Circadia combines transparency and innovation to put asset details at your fingerprints. From serial number and model to the location and lease expiration date, you have continuous visibility of key metrics to manage your assets efficiently across the lifecycle.';
export const LOGIN_SECTION_LIST_1 =
	'Access real-time data to optimize asset planning and refresh strategies.';
export const LOGIN_SECTION_LIST_2 =
	'Track leased and non-leased asset information through a single source.';
export const LOGIN_SECTION_LIST_3 =
	'Customize dashboard to seamlessly retrieve, organize and share data.';
export const LOGIN_SECTION_LIST_4 =
	'Initiate end-of-term options to purchase, renew or return leased assets.';

export const FIRST_NAME = 'First Name';
export const LAST_NAME = 'Last Name';
export const EMAIL = 'Email';
export const ROLE = 'Role';
export const ACTIONS = 'Actions';
export const EDIT = 'EDIT';
export const DEACTIVATE = 'DEACTIVATE';
export const ACTIVATE = 'ACTIVATE';

export const USER_ACCOUNTS = 'User Accounts';
export const USERS = 'Users';
export const CONTINUE_TO_DASHBOARD = 'Continue to Dashboard';
export const ADD_ANOTHER_USER = 'Add Another User';
export const CONFIRM_USER_CREATION = 'User Account Created Successfully.';
export const NO_ACCOUNT_INFO_PROVIDED = 'No account information provided.';
export const ACCOUNT_SPECIFICATIONS = 'Account Specifications';
export const ACCOUNT = 'Account';

export const UPLOAD_NLA_SUCCESS = 'Non-Leased Assets uploaded successfully.';
export const UPLOAD_BULK_UDF_TITLE = 'Upload File - Leased Asset';
export const UPLOAD_BULK_UDF_SUCCESS =
	'Leased Asset customer attribute field changes uploaded successfully. Monitor the banner for further updates.';
export const UPLOAD_BULK_UDF_HEADER_MESSAGE =
	'Only changes to your customer attributes will be processed.';
export const UPLOAD_BULK_UDF_DEFAULT_ERROR = 'Failed to upload file.';
export const UPLOAD_BULK_UDF_NO_FILE_ERROR = 'Please select a file to upload.';

export const INVOICE_CTA =
	'This is not an invoice, this information is for your records only. To request your invoice contact your Sales Representative.';
export const UNABLE_TO_LOAD_INVOICE =
	'Unable to load invoice details at this time. Please try again later.';

export const UPLOAD_SUCCESSFUL_STATUS =
	'Upload Successful: Your asset related field changes have been updated.';
export const UPLOAD_FAILED_STATUS =
	'Upload Error: Your asset related field changes could not be updated.';
export const UPLOAD_IN_PROGRESS_STATUS =
	'Upload In Progress: Your asset related field changes are being updated.';

// SearchableFilterField messages
export const START_TYPING_TO_SEARCH = 'Start typing to search...';
export const SEARCHING = 'Searching...';
export const NO_RESULTS_FOUND = 'No results found';

// Non-Leased Asset Modal Section Names
export const NON_LEASED_ASSET_SPEC = 'Asset Specifications';
export const NON_LEASED_CUSTOMER_ATTRIBUTES = 'Customer Attributes';
export const NON_LEASED_ASSET_LOCATION = 'Asset Location';
export const NON_LEASED_LEASE_DETAILS = 'Lease Details';
// Non-Leased Asset Column Headers
export const SCHEDULE_NO = 'Schedule No.';
export const TERM_HEADER = 'Term';
export const SUPPLIER_INVOICE_DATE = 'Supplier Invoice Date';

export const setTableMessage = (recordType: string): JSX.Element => (
	<Typography
		variant="body1"
		sx={{
			mb: 1,
		}}
	>
		Click on <b>{recordType}</b> to see the {recordType} details. Apply filters to reduce the number
		of options.
	</Typography>
);

// Forgot Password (not final content)
export const EMAIL_ADDRESS = 'Email Address';
export const CANCEL = 'Cancel';
export const FORGOT_PASSWORD_TITLE = 'Forgot your password?';
export const FORGOT_PASSWORD_DESCRIPTION =
	'Enter the email associated to your account and we’ll send an email with instructions to reset your password.';
export const VERIFICATION_CODE_LABEL = 'Verification Code';
export const NEW_OTP_CODE = 'Send a new code';
export const NO_EMAIL_ERROR = 'Please enter an email address';
export const INVALID_EMAIL_ERROR = 'Please enter a valid email address';
export const NO_VERIFICATION_CODE_ERROR = 'Enter a valid code';
export const CONFIRM_CODE_TITLE = 'Enter verification code';
export const CONFIRM_CODE_DESCRIPTION =
	"We've sent a verification code to your email. The code is valid for the next <30> minutes.";
export const CREATE_NEW_USER_PASSWORD_TITLE = 'Create your Password';
export const RESET_PASSWORD_TITLE = 'Reset your Password';
export const RESET_PASSWORD_DESCRIPTION = 'Create a new password to finish the process.';
export const NEW_PASSWORD = 'New Password';
export const CONFIRM_PASSWORD = 'Confirm Password';
export const PASSWORD_REQUIREMENTS = 'Passwords are case sensitive and must have:';
export const PASSWORD_REQUIREMENT_LENGTH = '9 or more characters';
export const PASSWORD_REQUIREMENT_MAX_LENGTH = '16 or fewer characters';
export const PASSWORD_REQUIREMENT_UPPERCASE = 'At least one uppercase letter';
export const PASSWORD_REQUIREMENT_LOWERCASE = 'At least one lowercase letter';
export const PASSWORD_REQUIREMENT_NUMBER = 'At least one number';
export const PASSWORD_REQUIREMENT_SPACES = 'No spaces';
export const PASSWORD_REQUIREMENT_NOT_MET = 'Your password does not meet all of the requirements';
export const PASSWORD_REQUIREMENT_MEETS = 'Your password meets all of the requirements';
export const PASSWORD_REQUIREMENT_NOT_MATCHING = 'Passwords do not match';
export const PASSWORD_REQUIREMENT_MATCHING = 'Your passwords match';
export const NO_PASSWORD_ERROR = 'Enter a password';
// Enrollment Start
export const ENROLLMENT_START_TITLE = 'Welcome to Circadia';
export const ENROLLMENT_START_DESCRIPTION = 'Enter your email address to get started';
export const ENROLLMENT_START_CONTINUE_BUTTON = 'Continue';
export const ENROLLMENT_START_EMAIL_ERROR = 'Enter a valid email address';

// Error Page
export const API_ERROR_PAGE_TITLE = 'Something went wrong';
export const API_ERROR_PAGE_DESCRIPTION_PREFIX = 'Please contact ';
export const API_ERROR_PAGE_DESCRIPTION_SUFFIX = ' for more assistance.';
export const API_ERROR_PAGE_DESCRIPTION_PREFIX_MOBILE = 'Please contact Circadia for support at ';
export const API_ERROR_PAGE_DESCRIPTION_SUFFIX_MOBILE = '.';
export const API_ERROR_PAGE_FAILED_TO_SEND_CODE = 'Failed to send a new code. Please try again.';

// Disclosure Start
export const DISCLOSURE_HEADER = 'Welcome to Circadia';
export const DISCLOSURE_SUCCESS_SUBHEADER = 'Your credentials have been created successfully!';
export const DISCLOSURE_REVIEW_SECTION_TITLE = 'Review Disclosures';
export const DISCLOSURE_REVIEW_SECTION_BODY =
	'Please review the Consent to Use of Electronic Records and Signatures and Circadia Terms and Conditions Agreement. You need to indicate your consent to access the Circadia.';
export const DISCLOSURE_INFOBOX_MESSAGE =
	'Some documents may be in PDF format. Please open the "Sample Document". If you can\'t open PDF\'s, download Adobe Reader at adobe.com or get the app.';
export const DISCLOSURE_SAMPLE_DOCUMENT_LINK = 'Sample Document';
export const DISCLOSURE_CONTINUE_BUTTON = 'Continue';

// Expired Link
export const EXPIRED_LINK_HEADER = 'This link has expired';
export const EXPIRED_LINK_ERROR_MESSAGE = 'Contact Circadia to request a new link.';
export const EXPIRED_LINK_CONTACT_EMAIL = 'Circadiarequests@Huntington.com.';

// Authentication - Verify OTP
export const VERIFY_OTP_TITLE = 'Enter verification code';
export const VERIFY_OTP_DESCRIPTION =
	"We've sent a verification code to your email. The code is valid for the next <30> minutes.";
export const VERIFY_OTP_INPUT_LABEL = 'Verification Code';
export const VERIFY_OTP_INPUT_PLACEHOLDER = '';
export const VERIFY_OTP_CONTINUE_BUTTON = 'Continue';
export const VERIFY_OTP_CODE_ERROR = 'Enter a valid code';

// Authentication -Lockout
export const LOCKOUT_TITLE = 'Too many attempts';
export const LOCKOUT_DESCRIPTION =
	'You have exceeded the maximum number of attempts to verify your identity. As a precaution, online access has been suspended. You can try again later.';
export const LOCKOUT_NEW_CODE_BUTTON = 'Get a new code';
export const CIRCADIA_HELP_EMAIL = 'circadiarequests@huntington.com';
export const EXPIRED_OK_BUTTON = 'Ok';

// Disclosure Acknowledgement
export const ACKNOWLEDGEMENT_HEADER = 'Accept the Agreements and Disclosures';
export const ACKNOWLEDGEMENT_TOP_SUBHEADER = 'Review Consent to Use of Electronic Records';
export const ACKNOWLEDGEMENT_TOP_CONSENT_LINK = 'Consent to Use of Electronic Records';
export const ACKNOWLEDGEMENT_DISCLOSURE_SUBHEADER = 'Disclosure Acknowledgement';
export const ACKNOWLEDGEMENT_DISCLOSURE_MESSAGE =
	'By checking this box, you acknowledge that you’ve had the opportunity to review the terms and conditions and that you agree to them.';
export const ACKNOWLEDGEMENT_TOP_ERROR_MESSAGE = 'Accept the consent to use of electronic records';

export const ACKNOWLEDGEMENT_BOTTOM_SUBHEADER = 'Review Terms & Conditions';
export const ACKNOWLEDGEMENT_BOTTOM_CONSENT_LINK = 'Circadia Terms & Conditions';
export const ACKNOWLEDGEMENT_BOTTOM_ERROR_MESSAGE = 'Accept the terms & conditions';
export const ACKNOWLEDGEMENT_CANCEL_BUTTON = 'Cancel';
export const ACKNOWLEDGEMENT_SUBMIT_BUTTON = 'Submit';

// Disclosure Acceptance Success
export const SUCCESS_HEADER = 'Success!';
export const SUCCESS_MESSAGE = 'Your Circadia account has been created.';
export const SUCCESS_CONTINUE_BUTTON = 'Continue to Login';

// Contact Us Modal
export const CONTACT_US_TITLE = 'Contact Us';
export const CONTACT_US_MESSAGE = `We're here to help. For questions about your account, please contact circadiarequests@huntington.com.`;
export const CONTACT_US_OK_BUTTON = 'Ok';

// User Guide Modal
export const USER_GUIDE_MODAL_TITLE = 'User Guide';

// Disclosure Cancellation Modal
export const DISCLOSURE_CANCELLATION_HEADER = 'Are You Sure You Want To Leave?';
export const DISCLOSURE_CANCELLATION_TOP_MESSAGE =
	'You need to indicate your consent to the agreements to \ncontinue.';
export const DISCLOSURE_CANCELLATION_BOTTOM_MESSAGE =
	"You'll be directed to these documents the next time you \nlog in.";
export const DISCLOSURE_CANCELLATION_CANCEL_BUTTON = 'No, continue';
export const DISCLOSURE_CANCELLATION_LEAVE_BUTTON = 'Yes, leave';

// Disclosure Document Modal
export const DISCLOSURE_ERECORDS_DOCUMENT_TITLE = 'Consent to Use of Electronic Records';
export const DISCLOSURE_TERMS_DOCUMENT_TITLE = 'Circadia Terms & Conditions';
export const DISCLOSURE_DOCUMENT_DOWNLOAD_BUTTON = 'Download';
export const DISCLOSURE_DOCUMENT_CONTINUE_BUTTON = 'Continue';

export const CONFIRM_NLA_DELETION =
	'Are you sure you want to permanently delete the selected assets? This action cannot be undone.';
export const NLA_ASSETS_DELETED_SUCCESS = 'Assets deleted successfully.';
export const NLA_ASSETS_DELETED_FAIL = 'Error while deleting assets.';

// Keep Alive Modal (idle timeout warning) — placeholder copy pending final copy from product
export const KEEP_ALIVE_MODAL_TITLE = 'Still there?';
export const KEEP_ALIVE_MODAL_BODY = "For your security, you'll be signed out in 2 minutes due to inactivity.";
export const KEEP_ALIVE_MODAL_STAY = 'Stay';
export const KEEP_ALIVE_MODAL_LEAVE = 'Leave';
